document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".carousel-section").forEach((carouselEl) => {
    const sectionId = carouselEl.getAttribute("data-carousel-id");
    const slidesPerView =
      parseInt(carouselEl.getAttribute("data-slides-per-view")) || 4;

    new Swiper(`#carousel-${sectionId}`, {
      slidesPerView: slidesPerView,
      spaceBetween: 32,
      navigation: {
        nextEl: `.custom-next-arrow-${sectionId}`,
        prevEl: `.custom-prev-arrow-${sectionId}`,
      },
      loop: false,
      breakpoints: {
        0: { slidesPerView: 1.7 },
        467: { slidesPerView: 2 },
        1024: { slidesPerView: slidesPerView },
      },
      on: {
        init: function (sw) {
          toggleNav(sw);
        },
        resize: function (sw) {
          toggleNav(sw);
        },
      },
    });
    function toggleNav(sw) {
      const totalSlides = sw.slides.length;
      const eff = sw.params.slidesPerView;

      if (totalSlides <= eff) {
        sw.navigation.prevEl.style.display = "none";
        sw.navigation.nextEl.style.display = "none";
      } else {
        sw.navigation.prevEl.style.display = "block";
        sw.navigation.nextEl.style.display = "block";
      }
    }
  });
});
